import { Card } from "@eworkit/iris";
import React, { FC } from "react";

import { IWithRouteNavigatorWrapped, withRouteNavigator } from "@/infrastructure/Route";

interface RouteCardProps extends IWithRouteNavigatorWrapped {}

const RouteCardComponent: FC<RouteCardProps> = ({ active, ...cardProps }) => {
  return <Card as="a" {...cardProps} />;
};

export const RouteCard = withRouteNavigator<RouteCardProps>(RouteCardComponent);
